document.addEventListener("DOMContentLoaded", () => {
    let mediaRecorder;
    let audioChunks = [];

    const recordBtn = document.getElementById('recordBtn');
    const stopBtn = document.getElementById('stopBtn');
    const box = document.getElementById('chat-messages-i');

    if (!recordBtn) return;

    function appendMessage(who, text) {
        const wrapper = document.createElement("div");
        wrapper.className = who === "user" ? "d-flex justify-content-end mb-10" : "d-flex justify-content-start mb-10";

        if (who === "user") {
            wrapper.className = "d-flex justify-content-end mb-10";
            wrapper.innerHTML = `
                  <div class="d-flex flex-column align-items-start">
                    <div class="d-flex align-items-center mb-2">
                      <div class="ms-3">
                        <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">Tú</a>
                      </div>
                    </div>
    
                    <div class="p-5 rounded bg-light-info text-gray-900 fw-semibold mw-lg-400px text-start" data-kt-element="message-text">
                      ${text}
                    </div>
                  </div>
                `;
        } else {
            texto = text.replace(/\n/g, "<br><br>");
            texto = texto.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

            wrapper.className = "d-flex justify-content-start mb-10";
            wrapper.innerHTML = `
                  <div class="d-flex flex-column align-items-end">
                    <div class="d-flex align-items-center mb-2">
                      <div class="me-3">
                        <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary ms-1">Asistente</a>
                      </div>  
                    </div>
                    <div class="p-5 rounded bg-light-primary text-gray-900 fw-semibold mw-lg-400px text-end" data-kt-element="message-text">
                      ${texto}
                    </div>
                  </div>
                `;
        }

        box.append(wrapper);
        box.scrollTop = box.scrollHeight;
    }

    function addMessage(role, text) {
        const div = document.createElement('div');
        div.textContent = `${role}: ${text}`;
        box.appendChild(div);
    }

    recordBtn.addEventListener('click', async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        mediaRecorder = new MediaRecorder(stream);
        mediaRecorder.ondataavailable = e => audioChunks.push(e.data);

        mediaRecorder.onstop = sendAudio;

        audioChunks = [];
        mediaRecorder.start();

        recordBtn.disabled = true;
        stopBtn.disabled = false;
        appendMessage("user", "<em>Grabando audio...</em>");
        // addMessage("Sistema", "Grabando audio...");
    });

    stopBtn.addEventListener('click', () => {
        mediaRecorder.stop();

        recordBtn.disabled = false;
        stopBtn.disabled = true;
        box.lastChild.remove();
        appendMessage("bot", "<em>Procesando audio...</em>");
        // addMessage("Sistema", "Procesando audio...");
    });

    async function sendAudio() {
        const blob = new Blob(audioChunks, { type: 'audio/webm' });
        const formData = new FormData();
        formData.append('audio_file', blob, 'grabacion.webm');

        try {
            const response = await fetch('/ai_chat/create_audio', {
                method: 'POST',
                body: formData,
                headers: { 'X-CSRF-Token': getCSRFToken() }
            });

            const data = await response.json();
            console.log("datadatadatadatadata");
            console.log(data);
            box.lastChild.remove();
            box.scrollTop = box.scrollHeight;

            if (data.error) {
                appendMessage("bot", <span className="text-danger">Error: ${data.error}</span>);
            } else {
                appendMessage("user", data.transcript);
                appendMessage("bot", data.ai_response);
            }


        } catch (e) {
            console.log(e)
            // appendMessage("bot", <span className="text-danger">Error al conectar con el servidor.</span>);
        }
    }

    function getCSRFToken() {
        return document.querySelector('meta[name="csrf-token"]').content;
    }

});
